/**
 *
 * @author Matthew Rawson @ 21/08/2018 20:03
 * @description
 * @notes
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {isEqual, get} from "lodash"

import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import padding from "@irati/ui/src/global/padding"
import {greys} from "@irati/ui/src/global/colors"
import Icon from "@irati/ui/src/Icon"
import {connect} from "@irati/store"
import {formatDriverDescription, formatDriverName, formatQuestionText} from "@irati/insights/utils/string"
import {groupQuestionsByDriver} from "@irati/insights/helpers/question"
import GetCycleWizard from "@irati/insights/apollo/query/wizard/Cycle"

import {CategoryTitle} from "../../CategoryTitle"
import CoreQuestionHeader from "./CoreQuestionHeader"
import {Para} from "../../../ui/Labels"
import {getDriverIcon} from "../../../helpers/DriverIcon"

const Wrapper = styled.div`
  margin-bottom: ${padding.base};
`

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: ${padding.small};
`

const QuestionWrapper = styled.div`
  background-color: white;
  box-shadow: 0 0 0 1px ${greys.mediumLight};
  padding: ${padding.small};
  display: flex;
  justify-content: space-between;
  align-items: center;

  :first-child {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }

  :last-child {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
`

const PadlockIcon = styled(Icon)`
  min-width: 16px;
  margin-left: 6px;
`


class QuestionManager extends Component {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    interest: PropTypes.object,
    isPhone: PropTypes.bool.isRequired
  }
  static defaultProps = {
    interest: null
  }


  constructor(props) {
    super(props)
    this.state = {
      formattedMessages: this.generateFormattedMessages(false)
    }
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.interest, this.props.interest)) {
      this.generateFormattedMessages()
    }
  }

  generateFormattedMessages = (setToState = true) => {
    const {formatMessage, interest} = this.props

    const formattedMessages = {
      coreQuestionTooltip: interest ? formatMessage({id: `${interest.contentId}.coreQuestionTooltip`}) : ""
    }

    if (setToState) this.setState({formattedMessages})

    return formattedMessages
  }


  render() {
    const idNamespace = id("QuestionManager", this.props)
    const {formatMessage, isPhone} = this.props
    const {formattedMessages} = this.state

    return (
      <GetCycleWizard useLoader={false}>
        {({schedule}) => {
          const questions = get(schedule, "questions.results")
          const placeholders = get(schedule, "preferences.placeholders")
          return (
            <div id={idNamespace}>
              {groupQuestionsByDriver(questions, null, true).map(({driver, questions: driverQuestions}) => (
                <Wrapper key={driver.name}>
                  <TitleRow>
                    <CategoryTitle
                      id={idNamespace}
                      category={formatMessage({id: "insights.global.keyDriver"})}
                      title={formatDriverName(this, driver)}
                      tooltip={formatDriverDescription(this, driver)}
                      tooltipPlacement={isPhone ? "bottom" : "right"}
                      icon={getDriverIcon(driver.contentId)} />
                    <CoreQuestionHeader id={idNamespace} tooltip={formattedMessages.coreQuestionTooltip} />
                  </TitleRow>
                  <div>
                    {driverQuestions.map((question) => (
                      <QuestionWrapper key={question.uuid}>
                        <Para medium flush>{formatQuestionText(this, question, placeholders)}</Para>
                        <PadlockIcon id={id("iconPadlock", idNamespace)} icon="padlock" size={16} />
                      </QuestionWrapper>
                    ))}
                  </div>
                </Wrapper>
              ))}
            </div>
          )
        }}
      </GetCycleWizard>
    )
  }
}

const mapStateToProps = ({mq}) => {
  return {
    isPhone: get(mq, "lessThan.medium", false)
  }
}


export default injectIntl(connect(mapStateToProps)(QuestionManager))
